// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ihFs","label":"styles_label__2QUoE"};